// blocks
import Membership from "./blocks/membership/membership-controller";

// components
import AddonCard from "./components/addon-card/addon-card-controller";
import SlidePanel from "./components/slide-panel/slide-panel-controller";
import ContractSwitcher from "./components/contract-switcher/contract-switcher-controller";
import Tabs from "./components/tabs/tabs-controller";
import Toast from "./components/toast/toast-controller";

// partials
import Topbar from "./partials/topbar/topbar-controller";

export default function registerDashboard(application) {
    // blocks
    application.register('membership', Membership);

    // components
    application.register('addon-card', AddonCard);
    application.register('slide-panel', SlidePanel);
    application.register('contract-switcher', ContractSwitcher);
    application.register('tabs', Tabs);
    application.register('toast', Toast);

    // partials
    application.register('topbar', Topbar);
}
